/**
 * Tamaños estandarizados para iconos en toda la aplicación
 * Usar estos valores para mantener consistencia visual
 */
export const ICON_SIZES = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 18,
  xl: 20,
  '2xl': 24,
  '3xl': 28,
} as const;

export type IconSize = keyof typeof ICON_SIZES;

/**
 * Helper para obtener el tamaño de icono
 * @param size - Tamaño del icono (default: 'md')
 * @returns Número de píxeles
 * 
 * @example
 * ```tsx
 * import { getIconSize } from '@/lib/icon-sizes';
 * import { Search } from 'lucide-react';
 * 
 * <Search size={getIconSize('lg')} />
 * ```
 */
export function getIconSize(size: IconSize = 'md'): number {
  return ICON_SIZES[size];
}



